export default [
  {
    path: '/engagement_letters/:token',
    name: 'public_engagement_letters',
    props: true,
    component: _ => import('@/views/public/EngagementLetter.vue'),
  },
]
